import { render } from "./CaseOpenerCard.vue?vue&type=template&id=2c3fdc8b&scoped=true"
import script from "./CaseOpenerCard.vue?vue&type=script&lang=js"
export * from "./CaseOpenerCard.vue?vue&type=script&lang=js"

import "./CaseOpenerCard.vue?vue&type=style&index=0&id=2c3fdc8b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/estate-boost-frontend/estate-boost-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c3fdc8b"]])

export default __exports__